var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemoveAddress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0007 8.16667C12.0007 8.225 12.0007 8.275 12.0007 8.33333C12.0007 10.2833 10.3757 12.8667 7.00065 15.95C3.62565 12.8667 2.00065 10.2917 2.00065 8.33333C2.00065 5.30833 4.20898 3.16667 7.00065 3.16667C7.28398 3.16667 7.56732 3.19167 7.83398 3.23333V1.55C7.55898 1.51667 7.28398 1.5 7.00065 1.5C3.50065 1.5 0.333984 4.18333 0.333984 8.33333C0.333984 11.1 2.55898 14.375 7.00065 18.1667C11.4423 14.375 13.6673 11.1 13.6673 8.33333C13.6673 8.275 13.6673 8.225 13.6673 8.16667H12.0007Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.00065 9.83333C7.92113 9.83333 8.66732 9.08714 8.66732 8.16667C8.66732 7.24619 7.92113 6.5 7.00065 6.5C6.08018 6.5 5.33398 7.24619 5.33398 8.16667C5.33398 9.08714 6.08018 9.83333 7.00065 9.83333Z",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7848 1.40001L14.6014 0.216675L12.8348 1.99167L11.0681 0.216675L9.88477 1.40001L11.6598 3.16667L9.88477 4.93334L11.0681 6.11667L12.8348 4.34167L14.6014 6.11667L15.7848 4.93334L14.0098 3.16667L15.7848 1.40001Z",
    fill: "#323232"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveAddress);
export default __webpack_public_path__ + "static/media/removeAddress.1b4c2eec8698472be3b5a1e068c4efe1.svg";
export { ForwardRef as ReactComponent };